import { Link, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../contexts/AuthContext'
import AnnouncementBar from '../announcements/AnnouncementBar'
import AppVersion from '../AppVersion'
import NotificationBell from '../NotificationBell'
import { BugReportDrawer } from '../feedback'
import AccountMenu from './AccountMenu'
import { cx, focusRing } from '../../lib/utils'
import Logo from '../ui/Logo'

/**
 * Layout route for the partner's area.
 *
 * Deliberately smaller than either other shell: a partner has a list of the
 * companies they created and, inside one, its people. There is no sidebar to
 * grow into the back-office by accident.
 */
export default function PartnerLayout() {
  const { t } = useTranslation()
  const { user } = useAuth()

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <AnnouncementBar />
      <header className="sticky top-0 z-40 border-b border-gray-200 bg-gray-50 dark:border-gray-800 dark:bg-gray-950/80">
        <div className="mx-auto flex h-16 w-full max-w-5xl items-center justify-between gap-4 px-4 sm:px-6">
          <Link to="/partner" className="flex shrink-0 items-center gap-2.5">
            <Logo />
            <span className="hidden rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-300 sm:block">
              {t('admin.role_partner')}
            </span>
          </Link>

          <div className="flex shrink-0 items-center gap-1">
            <NotificationBell />
            <AccountMenu
              trigger={
                <button
                  aria-label={t('nav.profile')}
                  className={cx(
                    'flex size-9 items-center justify-center rounded-full bg-primary-100 text-sm font-medium text-primary-700 transition hover:bg-primary-200 dark:bg-primary-900 dark:text-primary-300 dark:hover:bg-primary-800',
                    focusRing,
                  )}
                >
                  {user?.name?.charAt(0).toUpperCase()}
                </button>
              }
            />
          </div>
        </div>
      </header>

      {/* pb-24: the floating bug-report button would otherwise cover whatever ends the page. */}
      <main className="mx-auto w-full max-w-5xl px-4 pb-24 pt-8 sm:px-6">
        <Outlet />
        <AppVersion className="mt-12 text-center" />
      </main>

      <BugReportDrawer />
    </div>
  )
}
